import { getNextParentElement } from "../../../../common/utils/getNextParentElement";

const isGloballyActivated = window.o_util.toggle.get("oc_enable_floating_focus", false);
/**
 *
 *
 *
 *
 *
 *
 */
export function isActive(element: HTMLElement | null | undefined): element is HTMLElement {
  if (!element) return false;
  if (isGloballyActivated) return true;
  if (element.dataset.ocFloatingFocusV1Target !== undefined) return true;
  return isActive(getNextParentElement(element));
}
